@let bewe = beweInput();
<div class="flex flex-row justify-between flex-nowrap">
  <div class="flex flex-col">
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.nummer }}</span>
    <span class="text-lg font-semibold">{{
      bewe.artikelMengeOffen.artikel.artbez1
    }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez2 }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez3 }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez4 }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez5 }}</span>

    @if ($safeNavigationMigration(bewe?.artikelMengeOffen?.artikel?.beschreibung) | isDefinedNotEmpty) {
      <span
        class="text-sm color-light"
        [innerText]="$safeNavigationMigration(bewe?.artikelMengeOffen?.artikel?.beschreibung)"
      ></span>
    }

    @if (bewe?.dimension && bewe?.dimension?.massUnitId) {
      <span class="italic font-semibold text-sm mt-1"
        >{{ bewe?.dimension?.massUnitId }}</span
      >
    }

    @if ((bewe.zeilentext | isDefined) && bewe.zeilentext !== '') {
      <div
        class="flex flex-row mt-1 items-center"
      >
        <i class="fa-regular fa-circle-info"></i>
        <div class="w-full ml-2" [innerText]="bewe.zeilentext"></div>
      </div>
    }
  </div>

  @if (displayQuantity()) {
    <div class="flex items-center justify-end gap-2">
      <ng-content/>

      <div class="flex flex-col justify-center items-end">
        <div class="flex flex-row flex-nowrap color-light items-center text-xl">
        <span>{{
            useScannedQuantity()
              ? (bewe?.artikelMengeGescannt?.menge ?? bewe.artikelMengeOffen.menge)
              : bewe.artikelMengeOffen.menge
          }}</span>
          <span class="ml-1">
          @if (
            (bewe?.artikelMengeOffen?.artikel?.kzartikelart === 'DIF' || bewe?.artikelMengeOffen?.artikel?.kzartikelart === 'SDIF')
            ) {
            EH
          } @else {
            {{
              useScannedQuantity()
                ? (bewe?.artikelMengeGescannt?.einheit?.arteh ??
                  bewe.artikelMengeOffen.einheit.arteh)
                : bewe.artikelMengeOffen.einheit.arteh
            }}
          }
         </span>
        </div>

        @if (bewe.artikelMengeOffen.einheit.id !== bewe.artikelMengeOffen.einheit_lg.id) {
          <div
            class="flex flex-row flex-nowrap color-light items-center text-xl"
          >
        <span class="whitespace-nowrap"
        >=
          {{
            useScannedQuantity()
              ? (bewe?.artikelMengeGescannt?.menge_lg ?? bewe.artikelMengeOffen.menge_lg)
              : bewe.artikelMengeOffen.menge_lg
          }}</span
        >
            <span class="ml-1">{{
                useScannedQuantity()
                  ? (bewe?.artikelMengeGescannt?.einheit_lg?.arteh ??
                    bewe.artikelMengeOffen.einheit_lg.arteh)
                  : bewe.artikelMengeOffen.einheit_lg.arteh
              }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>

@if(((bewe?.subartikel?.length ?? 0) > 0) && (bewe.artikelMengeOffen.artikel.kzartikelart === 'MOD' || bewe.artikelMengeOffen.artikel.kzartikelart === 'SMO')) {
  <div class="flex flex-col border-l ml-2 border py-2">
    <div class="flex flex-col gap-2">
      @for (artikel of bewe?.subartikel; track $index) {
        <div class="flex flex-row items-center justify-between flex-nowrap px-2 mx-2"
             [class.border-b]="!$last"
        >
          <div class="flex flex-col">
            <span class="text-xs color-light">{{ artikel.artikelMenge.artikel.nummer }}</span>
            <span class="text-base font-semibold">{{
                artikel.artikelMenge.artikel.artbez1
              }}</span>
            <span class="text-xs color-light">{{ artikel.artikelMenge.artikel.artbez2 }}</span>
            <span class="text-xs color-light">{{ artikel.artikelMenge.artikel.artbez3 }}</span>
            <span class="text-xs color-light">{{ artikel.artikelMenge.artikel.artbez4 }}</span>
            <span class="text-xs color-light">{{ artikel.artikelMenge.artikel.artbez5 }}</span>

            @if (artikel?.artikelMenge?.artikel?.beschreibung | isDefinedNotEmpty) {
              <span
                class="text-xs color-light"
                [innerText]="artikel?.artikelMenge?.artikel?.beschreibung"
              ></span>
            }

            @if (artikel?.dimension && artikel?.dimension?.massUnitId) {
              <span class="italic font-semibold text-xs mt-1"
              >{{ artikel?.dimension?.massUnitId }}</span
              >
            }

            @if ((artikel.zeilentext | isDefined) && artikel.zeilentext !== '') {
              <div
                class="flex flex-row mt-1 items-center"
              >
                <i class="fa-regular fa-circle-info"></i>
                <div class="w-full ml-2" [innerText]="artikel.zeilentext"></div>
              </div>
            }
          </div>
          <span class="color-light text-lg">{{artikel.artikelMenge.menge}} {{artikel.artikelMenge.einheit.arteh}}</span>
        </div>
      }
    </div>
  </div>
}
